import { render, staticRenderFns } from "./ModalClaim.vue?vue&type=template&id=a389f6f6&scoped=true"
import script from "./ModalClaim.vue?vue&type=script&lang=js"
export * from "./ModalClaim.vue?vue&type=script&lang=js"
import style0 from "./ModalClaim.vue?vue&type=style&index=0&id=a389f6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a389f6f6",
  null
  
)

export default component.exports